import {
  Component, HostBinding, HostListener, Input,
} from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-form-control',
  templateUrl: './form-control.component.html',
  styleUrls: ['./form-control.component.scss'],
})
export class FormControlComponent {
  @Input() label: string;

  @Input() @HostBinding('class.disabled') isDisabled = false;

  @Input() isRequired = false;

  @Input() focusElement: HTMLElement;

  @HostBinding('class.focus') hasFocus = false;

  @Input()
  set errors$(errors$: Observable<string[]>) {
    this._errors$ = errors$;
    this.isInvalid$ = this.errors$.pipe(map((errors) => errors.length > 0));
    this.errorMessage$ = this.errors$.pipe(map((errors) => errors.join(', ')));
  }

  get errors$() {
    return this._errors$;
  }

  private _errors$;

  errorMessage$: Observable<string>;

  isInvalid$: Observable<boolean>;

  @HostListener('click')
  click() {
    if (!this.focusElement) {
      return;
    }

    this.focusElement.focus();
  }

  @HostListener('focusin')
  focusin() {
    this.hasFocus = true;
  }

  @HostListener('focusout')
  focusout() {
    this.hasFocus = false;
  }
}
